var app = angular.module('app-account', ['app-account-service', 'ngCookies']);

app.controller('Account', ['$scope', '$http', '$window', 'accountService', '$cookies', function ($scope, $http, $window, accountService, $cookies) {
    $scope.Account = '';
    $scope.isAccountSummaryOpen = false;
    $scope.culture = $window.culture;
    $scope.accountToken = '';
    $scope.loginEmail = '';
    $scope.loginPassword = '';
    $scope.errorLogin = '';
    $scope.proceedLoginButtonClicked = false;

    $scope.Login = function () {
        if ($scope.formLogin.$valid) {
            $scope.proceedLoginButtonClicked = true;
            $scope.errorLogin = '';
            accountService.Login($scope.loginEmail, $scope.loginPassword).then(function () {
                if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                    //window.location = window.masterDomain + '/' + culture + '/account';
                    window.location = '/' + culture + '/account';
                } else {
                    //show error
                    $cookies.remove('accountToken', { path: '/' + culture });
                    $scope.errorLogin = accountService._account.error;
                    $scope.proceedLoginButtonClicked = false;
                }
            });
        }
        else {
            if ($scope.formLogin.$error.required != undefined && $scope.formLogin.$error.required.length > 0) {
                $scope.errorLogin = lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formLogin.$error.email != undefined && $scope.formLogin.$error.email.length > 0) {
                $scope.errorLogin = lblWrongEmailHasBeenEntered;
                var emailField = window.document.getElementById('Email');

                if (emailField) {
                    emailField.focus();
                }
            }
        }
    }

    $scope.proceedPasswordForgotten = function () {
        accountService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/account/resetpasswordrequest';
            $http({
                method: 'POST',
                url: url,
                data: { email: $scope.loginEmail }
            }).then(function (res) {
                $scope.messagePasswordForgotten = '';
                $scope.errorPasswordForgotten = '';
                if (res.data.result == true) {
                    $scope.messagePasswordForgotten = res.data.message;
                } else {
                    $scope.errorPasswordForgotten = res.data.message;
                }
            });
        });
    }

    $scope.autoLogin = function () {
        //created for non-giant domains. To check cookie at masterdomain
        accountService.Login(null, null, null, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                window.location = '/' + culture + '/account';
            } else {
                $('.lds-spinner').remove();
                $('#app-account').show();
            }
        });
    }
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-account');
        angular.bootstrap(appID, ['app-account']);
    } catch (e) {
        //do nothing
    }
});